import styled from 'styled-components';
import { palette } from 'styled-tools';

import { IconButton, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin-bottom: 12px;
	display: flex;
	align-items: center;
`;

export const Label = styled.label`
	margin-right: 12px;
`;

export const InputContainer = styled.div`
	align-items: center;
	display: flex;
	position: relative;
	top: 2px;
`;

export const SpeakerIcon = styled(IconButton).attrs({ color: 'white' })`
	padding: 0;
`;

export const ProgressBarWrapper = styled.div`
	background-color: transparent;
	height: 2px;
	overflow: visible;
	width: 100%;
`;

export const RangeBar = styled.input`
	appearance: none;
	background-color: transparent;
	cursor: pointer;
	display: block;
	height: 2px;
	margin: 0;
	overflow: visible;
	padding-bottom: 3px;
	padding-top: 3px;
	position: relative;
	top: -5px;
	width: 100%;

	::-webkit-slider-runnable-track {
		background: transparent;
		height: 100%;
		width: 100%;
	}

	::-webkit-slider-thumb {
		appearance: none;
		background: ${palette('white')};
		border: 2px rgba(59, 160, 236, 1) solid;
		border-radius: 50%;
		box-sizing: content-box;
		display: block;
		height: 8px;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
		width: 8px;

		${minWidth('tablet')} {
			border: 4px rgba(59, 160, 236, 1) solid;
		}
	}

	::-moz-range-progress {
		background: ${palette('white')};
	}

	::-moz-range-track {
		background: rgba(255, 255, 255, 0.4);
	}

	::-moz-range-thumb {
		appearance: none;
		margin: 0;
		height: 14px;
		width: 14px;
		background: rgba(59, 190, 236, 1);
		border-radius: 100%;
		border: 0;
		display: block;
		transition: background-color 150ms;
	}

	::-ms-fill-lower {
		background: ${palette('white')};
	}

	::-ms-fill-upper {
		background: rgba(255, 255, 255, 0.4);
	}
`;

export const ProgressBar = styled.div<{ percentProgress: number }>`
	background: ${palette('gold')};
	border-radius: 100px;
	cursor: pointer;
	height: 2px;
	left: 0px;
	position: relative;
	top: 0px;
	width: calc(${p => p.percentProgress}% + 1px);
`;

export const UnfinishedProgressBar = styled.div`
	background: rgba(255, 255, 255, 0.4);
	border-radius: 100px;
	cursor: pointer;
	height: 2px;
	left: 0px;
	overflow: hidden;
	position: relative;
	top: 0px;
	width: 100%;
`;
